// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 320px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "container-2kMk_";
var _5 = "aviaTicketsBtn-13Zu_";
var _6 = "externalBtn-g0aMX";
export { _1 as "__esModule", _2 as "iphone5", _3 as "mobile", _4 as "container", _5 as "aviaTicketsBtn", _6 as "externalBtn" }
export default { "__esModule": _1, "iphone5": _2, "mobile": _3, "container": _4, "aviaTicketsBtn": _5, "externalBtn": _6 }
